import { render, staticRenderFns } from "./mass-actions-panel.vue?vue&type=template&id=002667b6&"
import script from "./mass-actions-panel.vue?vue&type=script&lang=js&"
export * from "./mass-actions-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports